/**
 * The roles this screen recognises, mirroring the server's split.
 *
 * These are not the security boundary. Every route behind this screen also runs
 * CalyxStaffGuard, which requires the caller's PropelAuth org to be Calyx Global, so the
 * screen is staff-only before any role is consulted. These lists decide which staff see
 * which buttons, and the server re-checks the same lists on every request.
 *
 * Built from roles that already exist so that shipping this needs no PropelAuth setup.
 * indices_editor and indices_publisher do not exist yet and are listed deliberately:
 * creating either one later grants exactly that capability to someone who holds no other
 * admin role, with no code change and nothing depending on it existing.
 *
 * Both lists live here so the route gate and the buttons cannot drift apart, which they
 * did when each kept its own copy.
 */
export const EDITOR_ROLES = [
  'internal_tool:admin',
  'internal_tool:super_admin',
  'internal_tool:team_lead',
  'internal_tool:indices_editor',
];

/**
 * Publishing writes to a public page under a trademarked index name that customers cite,
 * so it stays with the roles that already carry the most authority.
 */
export const PUBLISHER_ROLES = [
  'internal_tool:admin',
  'internal_tool:super_admin',
  'internal_tool:indices_publisher',
];

/** Anyone involved in the monthly update may open the screen and read the draft. */
export const INDICES_ROLES = [...new Set([...EDITOR_ROLES, ...PUBLISHER_ROLES])];
